import { useTheme, Grid, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

const IncidentDetailItem = ({ name, children, onClick }: {
  name?: string;
  onClick: (e: any) => void;
  children: React.ReactNode; 
}) => {
  const theme = useTheme(); 
  return (
    <Grid
      container
      onClick={onClick}
      sx={{
        justifyContent: 'space-between',
        p: '8px',
        mt: '8px',

        '&:hover': {
          bgcolor: theme.palette.grey[50]
        },

        '&:hover .hover-icon': {
          display: 'block'
        }
      }}>
      {
        name ? (
          <Grid>
            <Typography variant='caption'>{name}</Typography>
          </Grid>
        ) : null
      }
      <Grid>
        <EditIcon
          className='hover-icon'
          sx={{
            width: '15px',
            height: '15px',
            color: theme.palette.action.active,
            display: 'none'
          }}
        />
      </Grid>
      <Grid size={12}>
        {children}
      </Grid>
    </Grid>
  );
};

export default IncidentDetailItem;